import { AsyncButton } from "src/components/common/buttons/AsyncButton";
import { SalesCommissionViewExtraActionsProps } from "src/tenantCustomizations/TenantCustomizations.ts";
import { faCalculator } from "@fortawesome/pro-regular-svg-icons";
import i18n from "i18next";
import { SalvosSalesCommissionCalculationApi } from "src/api/generated/tenants/salvos/erp/sales/commission/api/salvosSalesCommissionCalculationApi.ts";
import { useConfirmDialog } from "src/components/common/dialogs/confirmDialog/ConfirmDialogContext.ts";
import { useMessageDialog } from "src/components/common/dialogs/messageDialog/MessageDialogContext.tsx";
import { formatSalvosOrderCommissionCalculationSummary } from "src/tenantCustomizations/tenants/salvos/sales/salesCommissions/formatSalvosOrderCommissionCalculationSummary.ts";
import { useContext } from "react";
import { CustomerOrdersPageContext } from "src/components/views/erp/sales/customerOrder/CustomerOrdersPageContext.tsx";
import { Typography } from "@mui/material";

export function SalvosSalesCommissionViewExtraActions({
	sourceType,
	sourceId,
	salesCommission,
	editingEnabled,
	refreshData,
}: SalesCommissionViewExtraActionsProps) {
	const showConfirmDialog = useConfirmDialog();
	const showMessageDialog = useMessageDialog();
	const customerOrderLinesRefreshRef = useContext(CustomerOrdersPageContext)?.customerOrderLinesRefreshRef;

	if (!editingEnabled) return null;
	if (sourceType !== "CUSTOMER_OFFER" && sourceType !== "CUSTOMER_ORDER") return null;

	return (
		<AsyncButton
			icon={faCalculator}
			label={i18n.t("calculate_commission")}
			onClick={async () => {
				if (sourceType === "CUSTOMER_ORDER") {
					const confirmed = await showConfirmDialog({
						message: i18n.t("calculate_order_commission_confirmation"),
					});
					if (!confirmed) return;

					const result = await SalvosSalesCommissionCalculationApi.calculateOrderSalesCommission({
						customerOrderId: sourceId,
						salesCommissionId: salesCommission.salesCommissionId,
					});
					await Promise.all([refreshData(), customerOrderLinesRefreshRef?.refresh()]);
					showMessageDialog({
						title: "Myyntitilauksen provisio laskettu",
						content: (
							<Typography sx={{ marginY: 1, marginX: 2, whiteSpace: "pre-line" }}>
								{formatSalvosOrderCommissionCalculationSummary(result)}
							</Typography>
						),
					});
				} else {
					await SalvosSalesCommissionCalculationApi.calculateOfferSalesCommission({
						customerOfferId: sourceId,
						salesCommissionId: salesCommission.salesCommissionId,
					});
					await refreshData();
				}
			}}
		/>
	);
}
